import { useQuery } from '@tanstack/react-query';
import { mockDelay } from '@/shared/api/mockDelay';
import { dashboardKpis, dashboardAlerts, moduleStatuses, dashboardWidgets } from './mockData';

export const useDashboardKpis = () =>
  useQuery({ queryKey: ['dashboard', 'kpis'], queryFn: () => mockDelay(dashboardKpis) });
export const useDashboardAlerts = () =>
  useQuery({ queryKey: ['dashboard', 'alerts'], queryFn: () => mockDelay(dashboardAlerts) });
export const useModuleStatuses = () =>
  useQuery({ queryKey: ['dashboard', 'modules'], queryFn: () => mockDelay(moduleStatuses) });
export const useDashboardWidgets = () =>
  useQuery({ queryKey: ['dashboard', 'widgets'], queryFn: () => mockDelay(dashboardWidgets) });
